<div class="row">
  <div class="row">
    <div class="col-6">
      <div>
        <i style="float:left;" class="material-icons button icon_adjust" *ngIf="languageKeyType == 23 && selectedLanguage && selectedLanguage != ''" (click)="onShowhtmlPreview()">preview</i>
        <ngx-select [ngStyle]="{'width' : (languageKeyType == 23 ? 'calc(100% - 30px)' : '100%')}" style="float: right;" [noAutoComplete]="true" [(ngModel)]="selectedLanguage" [disabled]="parentId == ''" [items]="localService.languagesEquivalent" [optionValueField]="'v1'" [optionTextField]="'v3'" (select)="onLoadLanguage()" placeholder="{{localService.languageContent.common.select}}">
        </ngx-select>
      </div>
    </div>
    <div class="col-6">
      <button type="button" style="width:100%" [disabled]="!selectedLanguage || selectedLanguage == ''" class="btn btn-primary" (click)="onUpdate()">{{localService.languageContent.common.update}}</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <textarea id="{{elementIds.content}}" style="margin:5px;" [ngClass]="isEnglishEditor ? 'en' : localService.getLanguageCode(selectedLanguage)" [(ngModel)]="languageContent" [disabled]="!selectedLanguage || selectedLanguage == ''" [ngStyle]="{'height' : maxBodyHeight + 'px'}"></textarea>
    </div>
  </div>
</div>
